import { IContent } from '../redux/contentUploaderModel';

const getThumbnailMedia = (content: IContent): string => {
  return content.previewUrl || content.localSrc || content.fileUrl || '';
};

export { getThumbnailMedia };
